/**
 * Add a notarized object.
 *
 * @param {Object} notarizedObject - The notarized-object data.
 */
export async function add(notarizedObject) {
  return fetch('/notarized-objects/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(notarizedObject)
  }).then((response) => {
    return response.json();
  });
}

/**
 * Get notarized objects for a specific person.
 *
 * @param {Object} personId - The person id.
 */
export async function get() {
  return fetch('/notarized-objects/', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return response.json();
  });
}

/**
 * Delete a notarized object.
 *
 * @param {Object} notarizedObject - The notarized-object data.
 */
export async function deleteNotarizedObject(notarizedObject) {
  return fetch('/notarized-objects/', {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(notarizedObject)
  }).then((response) => {
    return response.json();
  });
}
